import { type Commands } from '../commands';
import { UUID } from '../uuid/entity';
import { TechniqueMitigations } from './repository';
import { TechniqueMitigation } from './entity';
import { type TechniqueMitigationData } from './dto';

export class TechniqueMitigationsCommands
    implements
        Commands<
            TechniqueMitigations,
            TechniqueMitigation,
            TechniqueMitigationData
        >
{
    addAll(
        repo: TechniqueMitigations,
        data: TechniqueMitigationData[],
    ): TechniqueMitigations {
        repo.clear();
        data.forEach((techniqueMitigationData) => {
            this.add(repo, techniqueMitigationData);
        });
        return repo;
    }

    add(
        repo: TechniqueMitigations,
        data: TechniqueMitigationData,
    ): TechniqueMitigations {
        const techniqueMitigation = new TechniqueMitigation({
            id: data.id,
            mitigationId: data.mitigationId,
            techniqueId: data.techniqueId,
            description: data.description,
            srcId: data.srcId,
        });
        repo.add(techniqueMitigation);
        return repo;
    }

    update(
        repo: TechniqueMitigations,
        entity: TechniqueMitigation,
    ): TechniqueMitigation {
        repo.update(entity);
        return entity;
    }

    remove(repo: TechniqueMitigations, id: string): void {
        repo.remove(id);
    }

    create(
        repo: TechniqueMitigations,
        data: Omit<TechniqueMitigationData, 'id'>,
    ): TechniqueMitigation {
        const uuid = new UUID();
        const techniqueMitigation = new TechniqueMitigation({
            id: uuid.toString(),
            mitigationId: data.mitigationId,
            techniqueId: data.techniqueId,
            description: data.description,
            srcId: data.srcId,
        });
        repo.add(techniqueMitigation);
        return techniqueMitigation;
    }

    fromJSON(
        entity: TechniqueMitigation[],
        changeCallback: () => void,
    ): TechniqueMitigations {
        const newTechniqueMitigations = new TechniqueMitigations(
            changeCallback,
        );
        entity.forEach((techniqueMitigation) => {
            newTechniqueMitigations.add(
                new TechniqueMitigation({
                    id: techniqueMitigation.id,
                    mitigationId: techniqueMitigation.mitigationId,
                    techniqueId: techniqueMitigation.techniqueId,
                    description: techniqueMitigation.description,
                    srcId: techniqueMitigation.srcId,
                }),
            );
        });
        return newTechniqueMitigations;
    }
}
